<template>
  <v-card class="wrapper table-wrapper pa-0 ma-0">
    <iframe
      id="tickets-dash-frame"
      data-tickets-dash
      src="https://src.abriron.net/tickets-dash/"
      class="ticket-report-frame"
      frameborder="0"
    />
  </v-card>
</template>

<script>
export default {
  name: "ticketReport",
  mounted() {
    document.documentElement.classList.add("ai-cfo-no-page-scroll");
    document.body.classList.add("ai-cfo-no-page-scroll");

    const existing = document.querySelector("script[data-ai-cfo-embed]");
    if (existing) {
      existing.remove();
    }

    const script = document.createElement("script");
    script.src = "https://src.abriron.net/tickets-dash/js/parent-embed.js";
    script.async = true;
    script.setAttribute("data-tickets-dash-embed", "true");
    document.body.appendChild(script);
    this._embedScript = script;
  },
  beforeDestroy() {
    document.documentElement.classList.remove("ai-cfo-no-page-scroll");
    document.body.classList.remove("ai-cfo-no-page-scroll");
    if (this._embedScript && this._embedScript.parentNode) {
      this._embedScript.parentNode.removeChild(this._embedScript);
    }
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
  overflow: hidden;
}
.ticket-report-frame {
  width: 100%;
  height: 100% !important;
  min-height: 0 !important;
  border: 0;
  display: block;
}
.table-wrapper {
  min-height: 300px;
}
</style>
